










































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbAlert, mdbRow, mdbCol, mdbContainer, mdbSelect, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbIcon, mdbProgress, mdbTooltip, mdbPopover } from '@folky-tools/mdbvue';
import { VueGoodTable } from '@folky-tools/vue-good-table';
import { required, minValue } from 'vuelidate/lib/validators';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Project } from '@/models/projects/project';
import { Business } from '@/models/businesses/business';
import { Reference } from '@/models/references/reference';
import { ReferenceSku } from '@/models/references/reference-sku';
import { ReferenceSkuDiscount } from '@/models/references/reference-sku-discount';
import { usersService, projectsService, businessesService, axiosService, referencesService } from '@/services';

@Component({
    components: {
        mdbAlert,
        mdbRow,
        mdbCol,
        mdbContainer,
        mdbSelect,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        mdbBtn,
        mdbIcon,
        mdbProgress,
        mdbTooltip,
        mdbPopover,
        VueGoodTable,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    },
    validations: {
        projectId: { required, minValue: minValue(1) },
        businessId: { required, minValue: minValue(1) }
    }
})
export default class ApplyDiscountsView extends Vue {
    private showFilterModal: boolean = false;
    private projects: Project[] = [];
    private business: Business[] = [];
    private projectId: number = -1;
    private businessId: number = -1;
    private businessTradeName: string = '...';
    private globalDiscountPercent: number = 0;
    private isLoading: boolean = false;
    private referencesList: Reference[] = [];
    private referencesListCopy: Reference[] = [];
    private tableColumns: any[] = [];
    private totalRecords: number = 0;
    private changedReferencesList: ReferenceSkuDiscount[] = [];
    private applyingDataTimer?: NodeJS.Timeout;
    private savingDataTimer?: NodeJS.Timeout;
    private savingData: boolean = false;

    private async beforeMount(): Promise<void> {
        this.tableColumns = [
            { field: 'id', type: 'number', sortable: true, thClass: 'sorting' },
            {
                field: 'displayTitle',
                sortable: true,
                thClass: 'sorting',
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchByName'),
                    filterValue: null
                }
            },
            {
                field: 'category.text',
                sortable: true,
                thClass: 'sorting',
                filterOptions: {
                    enabled: true,
                    placeholder: '...',
                    filterDropdownItems: [],
                    filterValue: null
                }
            },
            { field: 'principalSkuPrice', sortable: false, type: 'number' },
            {
                field: 'principalSkuDiscountedPrice',
                sortable: false,
                type: 'number'
            },
            {
                field: 'isPublishedInAConsumer',
                sortable: false,
                filterOptions: {
                    enabled: true,
                    placeholder: '...',
                    filterDropdownItems: [
                        {
                            value: true,
                            text: this.$t('views.references.applyDiscountsView.published')
                        },
                        {
                            value: false,
                            text: this.$t('views.references.applyDiscountsView.unpublished')
                        }
                    ],
                    filterValue: null
                }
            }
        ];

        this.projects = await projectsService.getProjects();
        if (this.projects.length === 1) {
            this.projectId = this.projects[0].id;
            this.projects[0].selected = true;

            this.business = await businessesService.getBusinessByProjectId(this.projectId);
            if (this.business.length === 1) {
                this.business[0].selected = true;
                await this.onChangeBusiness(this.business[0].id, this.business[0].tradeName!);
                await this.applyFilter();
            } else {
                this.showFilterModal = true;
            }
        } else {
            this.showFilterModal = true;
        }
    }

    private async mounted(): Promise<void> {
        this.businessTradeName = this.$route.query.businessName ? this.$route.query.businessName.toString() : '...';
        this.$root.$emit('change-active-page', 'views.references.applyDiscountsView.title', this.businessTradeName);
    }

    private goBack(): void {
        if (window.history.length > 0) {
            this.$router.back();
        } else {
            this.$router.push('/dashboard');
        }
    }

    private async onChangeProject(value: number, text: string): Promise<void> {
        if (value) {
            this.projectId = value;
            this.business = await businessesService.getBusinessByProjectId(value);
            if (this.business.length === 1) {
                this.business[0].selected = true;
            }
        } else {
            this.business = [];
        }
    }

    private onChangeBusiness(value: number, text: string): void {
        if (value) {
            this.businessId = value;
            this.businessTradeName = text;
            this.$root.$emit('change-active-page', 'views.references.applyDiscountsView.title', this.businessTradeName);
        }
    }

    private async applyFilter(): Promise<void> {
        this.$v.projectId.$touch();
        this.$v.businessId.$touch();
        if (!this.$v.projectId.$error && !this.$v.businessId.$error) {
            this.showFilterModal = false;
            await this.loadItems();

            await usersService.logUserAction(
                new UserActionLogInfo({
                    type: UserActionType.HasVisited,
                    entity: UserActionEntityType.Businesses,
                    scope: UserActionScopeType.Discounts,
                    entityId: this.businessId
                })
            );
        }
    }

    private async loadItems(): Promise<void> {
        this.isLoading = true;
        const response: any = await axiosService.instance.get('references/organization/Product/query', {
            params: {
                $orderby: 'id desc',
                $filter: `projectId eq ${this.projectId} and businessId eq ${this.businessId}`
            }
        });

        this.referencesList = [];
        this.referencesListCopy = [];

        this.totalRecords = response.data.count;
        response.data.items.forEach((item: any) => {
            const reference: Reference = new Reference(item);
            this.referencesList.push(reference);
            this.referencesListCopy.push(reference.clone());
        });

        this.tableColumns.find((col: any) => col.field === 'category.text')!.filterOptions.filterDropdownItems = [
            ...new Set(
                this.referencesList
                    .map(r => (r.category !== undefined ? r.category.text : undefined))
                    .filter(text => text !== undefined)
                    .sort((left, right) => {
                        return left!.localeCompare(right!, this.$i18n.locale, {
                            sensitivity: 'base'
                        });
                    })
            )
        ];

        this.isLoading = false;
    }

    private applyDiscount(): void {
        this.isLoading = true;

        const filteredReferences: Reference[] = (this.$refs.referencesListTable as any).filteredRows ? (this.$refs.referencesListTable as any).filteredRows[0].children : this.referencesList;

        if (filteredReferences.length > 0) {
            this.applyingDataTimer = setInterval(() => {
                clearInterval(this.applyingDataTimer!);

                filteredReferences.forEach(filteredReference => {
                    const reference: Reference = this.referencesList.find(r => r.id === filteredReference.id)!;
                    if (reference.principalSku !== undefined && reference.principalSku.price !== null && reference.allSkuPricesAreEqual) {
                        reference.principalSku.discountedPrice = reference.principalSku.price - (this.globalDiscountPercent / 100) * reference.principalSku.price;
                        this.manageChangedReferencesList(reference.id, reference.principalSku.id, reference.principalSku.discountedPrice);
                    }
                });

                this.isLoading = false;
            }, 200);
        } else {
            this.isLoading = false;
        }
    }

    private resetDiscountChanges(): void {
        this.isLoading = true;

        const filteredReferences: Reference[] = (this.$refs.referencesListTable as any).filteredRows ? (this.$refs.referencesListTable as any).filteredRows[0].children : this.referencesList;

        if (filteredReferences.length > 0) {
            this.applyingDataTimer = setInterval(() => {
                clearInterval(this.applyingDataTimer!);

                filteredReferences.forEach(filteredReference => {
                    const reference: Reference = this.referencesList.find(r => r.id === filteredReference.id)!;
                    if (reference.principalSku !== undefined && reference.principalSku.price !== null && reference.allSkuPricesAreEqual) {
                        const referenceCopy: Reference = this.referencesListCopy.find(r => r.id === reference.id)!;
                        reference.principalSku.discountedPrice = referenceCopy.principalSku!.discountedPrice;
                        this.manageChangedReferencesList(reference.id, reference.principalSku.id, reference.principalSku.discountedPrice);
                    }
                });

                this.isLoading = false;
            }, 200);
        } else {
            this.isLoading = false;
        }
    }

    private removeDiscount(): void {
        this.isLoading = true;

        const filteredReferences: Reference[] = (this.$refs.referencesListTable as any).filteredRows ? (this.$refs.referencesListTable as any).filteredRows[0].children : this.referencesList;

        if (filteredReferences.length > 0) {
            this.applyingDataTimer = setInterval(() => {
                clearInterval(this.applyingDataTimer!);

                filteredReferences.forEach(filteredReference => {
                    const reference: Reference = this.referencesList.find(r => r.id === filteredReference.id)!;
                    if (reference.principalSku !== undefined && reference.principalSku.discountedPrice !== null && reference.allSkuPricesAreEqual) {
                        reference.principalSku.discountedPrice = null;
                        this.manageChangedReferencesList(reference.id, reference.principalSku.id, reference.principalSku.discountedPrice);
                    }
                });

                this.isLoading = false;
            }, 200);
        } else {
            this.isLoading = false;
        }
    }

    private isDiscountedPriceModified(referenceId: number, skuId: number): boolean {
        const reference: Reference | undefined = this.referencesList.find(r => r.id === referenceId);
        const sku: ReferenceSku | undefined = reference !== undefined && reference.principalSku !== undefined && reference.principalSku.id === skuId ? reference.principalSku : undefined;
        const referenceCopy: Reference | undefined = this.referencesListCopy.find(r => r.id === referenceId);
        const skuCopy: ReferenceSku | undefined = referenceCopy !== undefined && referenceCopy.principalSku !== undefined && referenceCopy.principalSku.id === skuId ? referenceCopy.principalSku : undefined;

        if (sku !== undefined && skuCopy !== undefined) {
            this.manageChangedReferencesList(referenceId, skuId, sku.discountedPrice);
            return sku.discountedPrice !== skuCopy.discountedPrice;
        }

        this.manageChangedReferencesList(referenceId, skuId, sku !== undefined ? sku.discountedPrice : null);

        return skuCopy !== undefined && skuCopy.discountedPrice !== null;
    }

    private manageChangedReferencesList(referenceId: number, skuId: number, discountedPrice: number | null = null) {
        const referenceCopy: Reference | undefined = this.referencesListCopy.find(r => r.id === referenceId);
        const skuCopy: ReferenceSku | undefined = referenceCopy !== undefined && referenceCopy.principalSku !== undefined && referenceCopy.principalSku.id === skuId ? referenceCopy.principalSku : undefined;

        if (referenceCopy !== undefined && skuCopy !== undefined) {
            const changedReference: ReferenceSkuDiscount | undefined = this.changedReferencesList.find(r => r.referenceId === referenceId && r.skuId === skuId);

            if (changedReference !== undefined) {
                if (discountedPrice === skuCopy.discountedPrice) {
                    this.changedReferencesList = this.changedReferencesList.filter(r => !(r.referenceId === referenceId && r.skuId === skuId));
                } else {
                    changedReference.discountedPrice = discountedPrice;
                }
            } else {
                if (discountedPrice !== skuCopy.discountedPrice) {
                    this.changedReferencesList.push(new ReferenceSkuDiscount(referenceId, skuId, discountedPrice));
                }
            }
        }
    }

    private revertChanges(): void {
        this.changedReferencesList = [];
        this.referencesListCopy.forEach((reference: Reference) => {
            if (reference.principalSku !== undefined) {
                this.referencesList.find(r => r.id === reference.id)!.principalSku!.discountedPrice = reference.principalSku!.discountedPrice;
            }
        });
    }

    private saveChanges(): void {
        this.savingData = true;
        this.savingDataTimer = setInterval(this.savingChanges, 200);
    }

    private async savingChanges(): Promise<void> {
        clearInterval(this.savingDataTimer!);

        for (const referenceSkuDiscount of this.changedReferencesList) {
            try {
                referenceSkuDiscount.savedCorrectly = await referencesService.applyReferenceSkuDiscount(referenceSkuDiscount);
            } catch {
                referenceSkuDiscount.savedCorrectly = false;
            }
        }

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasChanged,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.Discounts,
                entityId: this.businessId
            })
        );
    }

    private async closePageBlocker(): Promise<void> {
        this.savingData = false;
        this.changedReferencesList = [];
        await this.loadItems();
    }
}
